import { FC } from "react";
import { parseDate, _ } from "../../../utils/helpers";
import { useApp } from "../../../context/useApp";
import { Icon } from "../../../parts/Icon";
import { BookingContext } from "../../../parts/BookingContext";
import { ROUTES, SCREEN_BREAKPOINT_2, DEFAULT_DIALOG_HANDLE } from "../../../utils/symbols";

export const StepControls:FC = () => {

    const {
        state: { booking, screen, dialogHandles },
        actions: { navigate }
    } = useApp()

    const layoutDialog = dialogHandles.get('table-map-dialog') ?? DEFAULT_DIALOG_HANDLE

    const handleGoBack = () => {
        if (booking.step === 'shift') navigate(ROUTES.DATE)
        if (booking.step === 'personal-details') navigate(ROUTES.TABLE_LAYOUT)
        booking.goOneStepBackward().render()
        layoutDialog.closeDialog()
    }

    const handleGoToDateStep = () => {
        navigate(ROUTES.DATE)
        booking.setBookingStep('date').render()
        layoutDialog.closeDialog()
    }

    const handleGoToShiftStep = () => {
        navigate(ROUTES.TABLE_LAYOUT)
        booking.setBookingStep('shift').render()
        layoutDialog.closeDialog()
    }

     /* ----------------------------------------------------------
     |  DESKTOP CONTROLS AT PRODUCTS STEP
     ---------------------------------------------------------- */
    if (screen.width > SCREEN_BREAKPOINT_2 && ['products','tickets','shift'].includes(booking.step))
    return (
        <nav className="df aic jcsb w-100 pt-9 pb-3 step-controls p-a px-10" role="region" aria-label={_('0ar_booki__')}>
            <button
                aria-label={_('0ar_backt__')}
                className="button b-0 text s20-600 df aic nw p-0 py-5 h-100"
                onClick={handleGoBack}
            >
                <Icon icon="arrow-rounded-thick" className="mr-4" aria-hidden/>
            </button>
            <hr className="h-50p dib ml-5 mr-7" aria-hidden/>
            <BookingContext date shift zone accesible/>
        </nav>
    )
    /* ----------------------------------------------------------
     |  MOBILE CONTROLS AT PRODUCTS STEP
     ---------------------------------------------------------- */
    if (screen.width <= SCREEN_BREAKPOINT_2 && booking.step === 'products')
    return (
        <nav className="df aic jcsb w-100 py-6 step-controls p-a px-7" role="region" aria-label={_('0ar_booki__')}>
            <button
                aria-label={_('0ar_backt__')}
                className="button b-0 text s20-600 df aic nw p-0 py-5"
                onClick={handleGoBack}
            >
                <Icon icon="arrow-rounded-thick" className="mr-4 text white" aria-hidden/>
            </button>
            <hr className="h-33p dib ml-2 mr-7" aria-hidden/>
            <BookingContext date shift zone white mobile accesible/>
        </nav>
    )
    /* ----------------------------------------------------------
     |  MOBILE CONTROLS AT SHIFT & TICKETS STEP
     ---------------------------------------------------------- */
     if (screen.width <= SCREEN_BREAKPOINT_2 && ['shift', 'tickets'].includes(booking.step))
        return (
                <>
                <button
                    aria-label={_('2sh_chang__')}
                    className="b-0 nav-button text s20-600 df aic nw r3 text white button outline-shadow pl-8 pr-3 step-controls-go-back-button p-a"
                    onClick={handleGoBack}
                >
                    <Icon icon="arrow-rounded-thick" aria-hidden/>
                </button>
                <button
                    aria-label={_('2sh_chang_s')}
                    className="text nav-button nw df aifs button b-0 pl-7 py-2 r3 outline-shadow step-controls-go-to-date-button p-a" 
                    onClick={handleGoToDateStep}
                >
                    <span className={`text s20-600 df white`} aria-hidden>
                        <Icon icon={'calendar'} className="text white" style={{scale: '0.9'}}/>
                        <span>{parseDate('d Nov \'yy', booking.date)}</span>
                    </span>
                </button>

                {booking.step === 'tickets' && (
                    <button
                        onClick={handleGoToShiftStep}
                        className="nav-button text upper nw df px-7 py-5 aic ml-7 p-r shift-step-control r3 button outline-shadow step-controls-go-toshifts-button p-a"
                    >
                        <Icon icon={'swap'} className="mr-0" aria-hidden/>
                        <hr className="h-25p mx-5 " aria-hidden/>
                        <span className={`text s20-600 white`}>{parseDate('hh:mm', booking.date)}</span>
                    </button>
                )}
                </>
        )


    return null
}